import { makeStyles } from "@material-ui/core/styles";

function useMUIStyleHelper() {
  const mandatoryStyles = makeStyles(() => ({
    root: {
      "& .MuiAutocomplete-clearIndicator":{
        maxHeight: "3rem",
        color:"red",
        marginTop:"-3.7px"
      },
      "& 	.MuiAutocomplete-popupIndicator": {
        maxHeight: "3rem",
        color: "grey", 
        marginTop:"-2px"      
      },
      "& .MuiSvgIcon-root": {
        fontSize: "25.6px",
      },
      "& .MuiFormHelperText-root": {
        marginLeft: "1px",
        marginRight: "0px",
        marginTop: "0px",
        marginBottom: "0px",
      },
      "& label.Mui-focused": {
        background: "transparent",
        color: "black",
      },
      "& label.Mui-error": {
        color: "#d32f2f",
      },
      "& .MuiOutlinedInput-root.Mui-disabled": {
        backgroundColor: "#f2f2f2",

        "& > fieldset": { borderColor: "#00D600" },
      },
      "& .MuiFormLabel-root": {
        transform: "translate(13px, -9px) scale(0.9)",
        fontSize: "13px",
        transformOrigin: "top left",
        background: "transparent",
        color: "Black",
        width: "100%",
      },

      "& .MuiOutlinedInput-root": {
        "& > fieldset": {
          borderColor: "#00D600",
        },
        "&:hover fieldset": {
          borderColor: "#00D600",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#2A7AB8",
          borderWidth: "2px",
        },
      },
      "& fieldset": {
        minWidth: "auto",
        paddingRight: 1,
        marginRight: 0,
        paddingLeft: 10,
        marginLeft: 0,
      },
      "& .MuiInputLabel-shrink": {
        fontSize: 13,
        top: 1,
        width: "auto",
        background: "transparent",
        paddingLeft: 7,
        borderRadius: 3,
        paddingRight: 5,
        left: -6,
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        backgroundColor: "#ffffde",
      },
      hidden: {
        display: "none",
      },
      button: {
        background: "green",
      },
    },
  }));

  const nonMandatoryStyles = makeStyles(() => ({
    root: {
      "& .MuiAutocomplete-clearIndicator":{
        maxHeight: "3rem",
        color:"red",
        marginTop:"-3.7px"
      },
      "& 	.MuiAutocomplete-popupIndicator": {
        maxHeight: "3rem",
        color: "grey", 
        marginTop:"-2px"      
      },
      "& .MuiSvgIcon-root": {
        fontSize: "25.6px",
      },
      "& .MuiFormHelperText-root": {
        marginLeft: "1px",
        marginRight: "0px",
        marginTop: "0px",
        marginBottom: "0px",
      },
      "& label.Mui-error": {
        color: "#d32f2f",
      },
      "& .MuiOutlinedInput-root.Mui-disabled": {
        backgroundColor: "#f2f2f2",
        
      },
      "& .MuiFormLabel-root": {
        transform: "translate(13px, -9px) scale(0.9)",
        fontSize: "13px",
        padding: "0px 0px",
        background: "transparent",
        color: "Black",
      },
      "& fieldset": {
        minWidth: "auto",
        paddingRight: 15,
        marginRight: 0,
        paddingLeft: 10,
        marginLeft: 0,
      },
      "& .MuiInputLabel-shrink": {
        fontSize: 13,
        top: 1,
        width: "auto",
        background: "transparent",
        paddingLeft: 7,
        borderRadius: 3,
        paddingRight: 0,
        left: -6,
      },
      "& .MuiOutlinedInput-root": {
        "& > fieldset": {
          // borderColor: "#00D600"
        },
        "&.Mui-focused fieldset": {
          borderColor: "#2A7AB8",
          borderWidth: "2px",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        backgroundColor: "#ffffde",
      },
      hidden: {
        display: "none",
      },
      button: {
        background: "green",
      },
    },
  }));

  return {
    mandatoryClasses: mandatoryStyles(),
    nonMandatoryClasses: nonMandatoryStyles(),
  };
}

export default useMUIStyleHelper;
